import { html } from "lit";
import { queryAssignedElements, state } from "lit/decorators.js";
import { ifDefined } from "lit-html/directives/if-defined.js";
import { when } from "lit-html/directives/when.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { getInputClasses, getContainerClasses, getTextLabelClasses } from "./utils.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./checkbox.selectors.js";
import "../../atom/Icon/index.js";
import "../../atom/Text/index.js";
import "../Tooltip/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfCheckbox = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_size = "medium";
    this.dsf_checked = false;
    this.disabled = false;
    this.dsf_indeterminate = false;
    this._hasInfoTooltip = false;
  }
  setTabIndex(index) {
    this._tabIndex = index;
  }
  onChange() {
    this.dsf_checked = !this.dsf_checked;
    this.emit({ name: "change", payload: this.dsf_checked });
  }
  handleInfoTooltipSlotChange() {
    this._hasInfoTooltip = this.infoTooltipSlot && this.infoTooltipSlot.length > 0 || false;
  }
  renderInfoTooltip() {
    return this._hasInfoTooltip ? html`
          <dsf-tooltip
            dsf_placement="bottom"
            dsf_size="small"
            dsf_type="outlined"
            exportparts="dropdown: info-tooltip-dropdown"
          >
            <div class="flex items-center" slot="anchor">
              <dsf-icon
                dsf_name="CircleHelp"
                dsf_size="12px"
                class="ml-4 text-neutral-400"
              ></dsf-icon>
            </div>
            <slot name="info-tooltip" @slotchange=${this.handleInfoTooltipSlotChange}></slot>
          </dsf-tooltip>
        ` : html` <slot name="info-tooltip" @slotchange=${this.handleInfoTooltipSlotChange}></slot> `;
  }
  renderErrorMessage() {
    return when(
      this.dsf_error_message,
      () => html`
        <dsf-text dsf_level="xxs" dsf_color="error" dsf_intensity="300">
          ${this.dsf_error_message}
        </dsf-text>
      `
    );
  }
  render() {
    const inputClass = getInputClasses(this);
    const containerClass = getContainerClasses(this);
    const textLabelClass = getTextLabelClasses(this.dsf_size);
    const checkboxComponent = html`
      <label class="${containerClass}">
        <span class="${textLabelClass}" data-skeleton>${this.dsf_label}</span>
        <input
          @change="${this.onChange}"
          type="checkbox"
          ?disabled="${this.disabled}"
          ?checked="${this.dsf_checked}"
          class="${inputClass}"
          tabindex=${ifDefined(this._tabIndex)}
          data-skeleton
          ${testingAttr(TestingAttrs.input)}
        />
        ${this.renderInfoTooltip()}
      </label>
    `;
    return this.dsf_error_message ? html`
          <div class="flex flex-col gap-2">${checkboxComponent} ${this.renderErrorMessage()}</div>
        ` : checkboxComponent;
  }
};
__decorateClass([
  prop({ type: String })
], DsfCheckbox.prototype, "dsf_label", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfCheckbox.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfCheckbox.prototype, "dsf_checked", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfCheckbox.prototype, "disabled", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfCheckbox.prototype, "dsf_indeterminate", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfCheckbox.prototype, "dsf_error_message", 2);
__decorateClass([
  queryAssignedElements({ flatten: true, slot: "info-tooltip" })
], DsfCheckbox.prototype, "infoTooltipSlot", 2);
__decorateClass([
  state()
], DsfCheckbox.prototype, "_tabIndex", 2);
__decorateClass([
  state()
], DsfCheckbox.prototype, "_hasInfoTooltip", 2);
__decorateClass([
  preventDefault
], DsfCheckbox.prototype, "onChange", 1);
DsfCheckbox = __decorateClass([
  defineElement("dsf-checkbox")
], DsfCheckbox);
export {
  DsfCheckbox
};
